import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import Select from "react-select";
import "./style.scss";

const SelectFilter = ({data, className}) => {
    const {key, label, placeholder} = data;
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultFilter = searchParams.get(key);
    const [options, setOptions] = useState(data.options);
    const [selectedValue, setSelectedValue] = useState();

    useEffect(() => {
        let findItem = options.find(f => f.value === defaultFilter);
        if (findItem) setSelectedValue(findItem);
        else searchParams.delete(key);
    }, []);

    useEffect(() => {
        setOptions(data.options)
    }, [data.options])

    useEffect(() => {
        if (typeof selectedValue !== "undefined") setValueToUrl()
    }, [selectedValue])

    const setValueToUrl = () => {
        let newParamsQuery = new URLSearchParams(searchParams);
        if (selectedValue?.value !== null && typeof selectedValue?.value !== "undefined") newParamsQuery.set(key, selectedValue?.value);
        else newParamsQuery.delete(key);
        setSearchParams(newParamsQuery);
    }

    const updateSelectedFilter = (value) => {
        setSelectedValue(value);

        let newParamsQuery = new URLSearchParams(searchParams);
        if (newParamsQuery.get("page")) {
            newParamsQuery.delete("page");
            setSearchParams(newParamsQuery);
        }
    }

    return (
        <section className={`select-filter ${className}`}>
            <h6 className="title mr-1 my-auto">
                {label}
            </h6>
            <Select
                options={options}
                value={selectedValue}
                onChange={updateSelectedFilter}
                className='react-select'
                classNamePrefix='select'
                name={key}
                inputId={key}
                placeholder={placeholder}
                isClearable
                noOptionsMessage={() => ("موردی وجود ندارد")}
            />
        </section>
    );
}

export default SelectFilter;
